import React, { useEffect, useRef } from 'react';
import Webamp from 'webamp';
import { initialTracks } from './config';

// Winamp skins — removed external CDN URLs that were failing
// Using only the default built-in skin which always works

function Winamp({ onClose, onMinimize }) {
  const ref = useRef(null);
  const webamp = useRef(null);
  useEffect(() => {
    const target = ref.current;
    if (!target) {
      return;
    }
    webamp.current = new Webamp({
      initialTracks,
      enableHotkeys: true,
      // Milkdrop visualizer via Butterchurn — load ALL presets (base + extra + image)
      __butterchurnOptions: {
        importButterchurn: () => import('butterchurn'),
        getPresets: () => {
          // Load all preset packs for maximum visualizer variety
          const presets = {};

          // Base presets
          try {
            const base = require('butterchurn-presets/lib/butterchurnPresetsBase.min');
            Object.assign(presets, base.default || base);
          } catch (e) {
            try {
              const base = require('butterchurn-presets');
              const basePresets = base.getPresets ? base.getPresets() : (base.default || base);
              Object.assign(presets, basePresets);
            } catch (e2) { /* fallback */ }
          }

          // Extra presets
          try {
            const extra = require('butterchurn-presets/lib/butterchurnPresetsExtra.min');
            Object.assign(presets, extra.default || extra);
          } catch (e) { /* not available */ }

          // Extra2 presets
          try {
            const extra2 = require('butterchurn-presets/lib/butterchurnPresetsExtra2.min');
            Object.assign(presets, extra2.default || extra2);
          } catch (e) { /* not available */ }

          return Object.keys(presets).map(name => ({
            name,
            butterchurnPresetObject: presets[name],
          }));
        },
        butterchurnOpen: true,
      },
      windowLayout: {
        main: { position: { top: 0, left: 0 } },
        equalizer: { position: { top: 116, left: 0 }, closed: false },
        playlist: { position: { top: 232, left: 0 }, size: { extraHeight: 0, extraWidth: 0 } },
        milkdrop: { position: { top: 0, left: 275 }, size: { extraHeight: 12, extraWidth: 12 } },
      },
    });
    webamp.current.renderWhenReady(target).then(() => {
      target.appendChild(document.querySelector('#webamp'));

      // Play the classic "Winamp... it really whips the llama's ass!" on startup
      try {
        const llamaAudio = new Audio('/sounds/llama.mp3');
        llamaAudio.volume = 0.6;
        llamaAudio.play().catch(() => {
          // Autoplay may be blocked — that's OK, browsers need user interaction first
        });
      } catch (e) {
        // Sound file not available — no worries
      }
    });
    return () => {
      webamp.current.dispose();
      webamp.current = null;
    };
  }, []);
  useEffect(() => {
    if (webamp.current) {
      webamp.current.onClose(onClose);
      webamp.current.onMinimize(onMinimize);
    }
  });
  return (
    <div
      style={{ position: 'fixed', left: 0, top: 0, right: 0, bottom: 0 }}
      ref={ref}
    />
  );
}

export default Winamp;
